import { useTheme } from "@/theme/ThemeProvider";
import React, { createContext, useContext, useState } from "react";
import { View } from "react-native";

/**
 * FAB-Slot: entkoppelt die schwebende Hauptaktion vom (ggf. überlaufenden) Screen.
 * Der FAB wird in der App-Hülle über der Bottom-Bar gerendert – dadurch bleibt er
 * auch bei eingeblendetem Offline-Banner sichtbar, ohne dass gescrollt werden muss.
 *
 * Zwei getrennte Contexts: der Setter ist stabil (Screens re-rendern nicht, wenn sich
 * der FAB-Inhalt ändert), nur der Renderer hört auf Änderungen des Knotens.
 */

type FabSetter = (node: React.ReactNode) => void;

const FabSetterContext = createContext<FabSetter>(() => {});
const FabNodeContext = createContext<React.ReactNode>(null);

export function FabSlotProvider({ children }: { children: React.ReactNode }) {
  const [node, setNode] = useState<React.ReactNode>(null);
  return (
    <FabSetterContext.Provider value={setNode}>
      <FabNodeContext.Provider value={node}>{children}</FabNodeContext.Provider>
    </FabSetterContext.Provider>
  );
}

export function useFabSetter(): FabSetter {
  return useContext(FabSetterContext);
}

/** Rendert den aktuellen FAB unten rechts. In der App-Hülle über der Bottom-Bar platzieren. */
export function FabSlotRenderer() {
  const node = useContext(FabNodeContext);
  const { theme } = useTheme();
  if (!node) return null;
  return (
    <View
      pointerEvents="box-none"
      style={{ position: "absolute", left: 0, right: 0, top: 0, bottom: 0 }}
    >
      <View style={{ position: "absolute", right: theme.space.lg, bottom: theme.space.lg }}>
        {node}
      </View>
    </View>
  );
}
